import { SHOW_TAB, SHOW_LOADER, SHOW_MOBILE } from 'fixtures/actions'

export const toggleIsShowTab = (show) => {
  return dispatch => {
    dispatch({
      type: SHOW_TAB,
      payload: show
    })
  }
}

export const toggleIsLoading = (show) => {
  return dispatch => {
    dispatch({
      type: SHOW_LOADER,
      payload: show
    })
  }
}

export const toggleIsMobileView = (width) => {
  return dispatch => {
    dispatch({
      type: SHOW_MOBILE,
      payload: width > 1024 ? false : true
    })
  }
}
